<template>
    <div class="calendar-popup-time-wrapper" @click.self="clickClosePopupMobile()">
        <div class="calendar-popup-time" 
            id="calendar-popup-time"
            >
            <div class="calendar-popup-time__title">
                Выберите время
            </div>
            <div class="calendar-popup-time__svg"
                @click="clickClosePopup()"
            >
                <svg viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
                    <path opacity="1" d="M13 1L1 13M1 1L13 13" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
            </div>
            <div class="calendar-popup-time__time">
                {{ day }} {{name}}, {{ selectTime }}
            </div>
            <div class="calendar-popup-time__swiper">
              <carousel
                  :per-page="1"
                  @page-change="pageChnage"
                  :mouse-drag="true"
                  :paginationEnabled="false"
                  :spacePadding="150"
                  :navigateTo="activeIndex"
              >
                <slide
                    v-for="(item, index) in timeFilter"
                    :key="index"
                    @slide-click="slideClick"
                >
                    <div
                      @click="clickEl(item, index)"
                      class="calendar-popup-time__column"
                      :class="{ 'calendar-popup-time__column-prime-time' : item.primetime}"
                      :style="`
                        background-color: ${ checkColor(item, index)}
                      `"
                      >
                      <div class="calendar-popup-time__column-text">
                        {{ item.number }}
                      </div>
                      <div class="calendar-popup-time__price">
                        <span v-if="!item.primetime"> {{ Math.trunc(markup + selectSurveyPrice) }}  ₽</span>
                        <span v-if="item.primetime"> {{ Math.trunc((markup *  pricePrimeTime) + selectSurveyPrice)}}  ₽</span>
                        <div class="calendar-popup-time__price-figure">
                        </div>
                      </div>
                    </div>
                </slide>
              </carousel>
            </div>
                <div class="calendar-popup-time__button"
                    :class="{'calendar-popup-time__button-disabled' : !is_button}"
                    @click="clickOkTime()"
                >
                    <span>Подтвердить</span>
                </div>
        </div>
    </div>
</template>

<script>

    import { Carousel, Slide } from 'vue-carousel';

    export default {
        async mounted() {
            this.localPrice = this.price

            this.times.forEach((item, index) => {
                if(item.available) {
                    this.timeFilter.push(item)
                } 
            })

            // this.currentTime = this.timeFilter[0].number

            this.$store.dispatch('date/setSelectTime', {
                time: this.timeFilter[0].number
            })

        },  
        data() {
            return {
                localPrice: false,
                currentTime: false,
                activeIndex: 0,
                timeFilter: [],
                statusButton: true,
                is_button: true
            }
        },
        props: {
            day: {
                default: false
            },
            dayInfo: {
                default: false
            },
            times: {
                default: false
            },
            name: {
                default: ''
            },
            price: {
                default: 500
            },
            priceWeekend: {
                default: 1
            },
            priceHolidays: {
                default: 1
            },
            pricePrimeTime: {
                default: 1
            }
        },
        components: {
          Carousel,
          Slide,
        },
        methods: {
            pageChnage(e) {
              this.activeIndex = e

              let time = this.timeFilter[e].number
              let primetime = this.timeFilter[e].primetime

              this.setInfoSLide(time, primetime)

            },
            clickEl(item, index) {
              this.activeIndex = index
              this.setInfoSLide(item.number, item.primetime)
            },
            checkColor(item, index) {
              if(this.activeIndex === index) {
                return '#674FFD'
              } else {
                return '#E4E1E9'
              }
            },
            slideClick(e) {
              // console.log(e)
            },
            async clickOkTime() {
                if(this.is_button) {
                    this.$emit('clickOkTime')
                }
            },
            async setInfoSLide(time, primeTime) {

                this.is_button = false

                await this.$store.dispatch('date/setSelectTime', {
                    time: time
                })

                await this.$store.dispatch('date/setPrimeTime', {
                    status: primeTime
                })


                this.is_button = true
            },
            async clickClosePopup() {
                this.$emit('clickClosePopup')
            },
            async clickClosePopupMobile() {
                this.$emit('clickClosePopupMobile')
            },
            async slideChange() {
                window.navigator.vibrate(20)
            }
        },
        computed: {
            markup() {
                if(this.dayInfo.weekend && !this.dayInfo.holiday) {
                    this.localPrice = this.localPrice * this.priceWeekend
                    return this.localPrice
                }
                
                if(!this.dayInfo.weekend && this.dayInfo.holiday) {
                    this.localPrice = this.localPrice * this.priceHolidays
                    return this.localPrice
                } 
                
                if(this.dayInfo.weekend && this.dayInfo.holiday) {
                    this.localPrice = this.localPrice * this.priceHolidays
                    return this.localPrice
                }

                if(!this.dayInfo.weekend && !this.dayInfo.holiday) {
                    return this.localPrice
                }
            },
            selectTime() {
                return this.$store.getters['date/selectTime']
            },
            selectSurveyPrice() {
                return this.$store.getters['survey_price/selectSurveyPrice']
            }
        }
    }
</script>

<style lang="less">

    @import '~/assets/smart-grid.less';

    .calendar-popup-time-wrapper {
        width: 100%;
        height: 100%;
        position: absolute;
        min-height: 430px;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0px;
        top: 0px;
        z-index: 12;
    }

    .VueCarousel {
      margin: 40px 0px 40px 0px;
    }

    .VueCarousel-inner {
      //padding-left: 150px;
    }

    .VueCarousel-wrapper {
      overflow: inherit !important;
    }

    .calendar-popup-time {
        width: 342px;
        background-color: white;
        display: flex;
        flex-direction: column;
        border-radius: 13px;
        position: relative;
    }

    .calendar-popup-time__title {
        margin-top: 16px;
        margin-left: 16px;
        font-family: 'Montserrat-Bold';
        font-size: 22px;
        line-height: 28px;
        margin-right: 16px;
    }

    .calendar-popup-time__svg {
        position: absolute;
        top: -30px;
        right: 3px;
        width: 18px;
        height: 18px;
        display: block;
        cursor: pointer;
        .ms-block({
            display: none;
        })
    }

    .calendar-popup-time__svg svg {
        width: 100%;
        height: 100%;
        fill: black;
    }

    .calendar-popup-time__time {
        color: #000000;
        opacity: 0.5;
        font-size: 17px;
        line-height: 20px;
        font-family: 'Roboto-Medium';
        margin-left: 16px;
        margin-top: 3px;
    }

    .calendar-popup-time__swiper {
      overflow: hidden;
      max-width: 342px;
    }

    .calendar-popup-time__column {
        width: 24px;
        height: 40px;
        background: #E4E1E9;
        border-radius: 4px 4px 0px 0px;
        position: relative;
        cursor: pointer;
        z-index: 12;
    }

    .calendar-popup-time__column input {
        width: 100%;
        height: 100%;
        cursor: pointer;
        position: absolute;
        left: 0px;
        top: 0px;
        z-index: 2;
        opacity: 0;
    }

    .calendar-popup-time__column-prime-time {
        height: 63px;
    }

    .calendar-popup-time__price {
        display: none;
    }

    .calendar-popup-time__price-figure {
        display: none;
    }

    .swiper-slide-active .calendar-popup-time__price {
        position: absolute;
        top: -52px;
        left: 10px;
        display: flex;
        justify-content: center;
        background-color:#674FFD;
        width: max-content;
        border-radius: 5px;
        line-height: 14px;
        font-size: 16px;
        color: #FFFFFF;
        font-family: 'Montserrat-Bold';
    }

    .swiper-slide-active .calendar-popup-time__price .calendar-popup-time__price-figure {
        display: block;
        position: absolute;
        left: -10px;
        bottom: -20px;
        border: 20px solid transparent; border-left: 20px solid #674FFD;
        transform: scale(.5);
        z-index: 11px;
    }

    .swiper-slide-active .calendar-popup-time__price span {
        margin: 10px 13px;
    }

    .calendar-popup-time__column-text {
        position: absolute;
        bottom: -17px;
        font-family: 'Montserrat-Medium';
        line-height: 14px;
        font-size: 10px;
        color: #808080;
    }

    .calendar-popup-time__column-text-active {
        position: absolute;
        color: #31283D;
    }

    #calendar-popup-time .swiper-container {
        min-height: 150px;
    }

    .swiper-slide-active .calendar-popup-time__column {
        background: #674FFD;
        z-index: 13;
    }

    #calendar-popup-time .swiper-wrapper {
        margin-left: 110px;
        margin-top: 60px;
        display: flex;
        align-items: flex-end;
    }

    .calendar-popup-time__button {
        background: #674FFD;
        border-radius: 5px;
        width: 310px;
        height: 44px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Montserrat-Medium';
        color: white;
        margin: 0 auto;
        margin-bottom: 32px;
        cursor: pointer;
        transition-duration: .4s;
    }

    .calendar-popup-time__button-disabled {
        background: grey;
        cursor: inherit;
        transition-duration: .4s;
    }
</style>